<div class="modal-header" id="confirmation-signature-modal-title">
    <h3 class="modal-title" id="modal-title" translate="CONFIRMATION_SIGNATURE_TITLE"></h3>
</div>
<div class="modal-body" id="modal-body">
    <div class="row">
        <div class="col-12 col-sm-6">
            <ng-container class="customerSignature" *ngIf="!!customerSignature">
                <label
                    class="col-12 col-form-label text-start"
                    translate="CONFIRMATION_SIGNATURE_CUSTOMER_LABEL"
                ></label>
                <div class="col-12 col-lg-10">
                    <img
                        class="w-100"
                        *ngIf="customerSignatureUrl"
                        [src]="customerSignatureUrl"
                        alt="Customer signature"
                    />
                </div>
                <div *ngIf="!!customerSignature" class="d-block d-lg-none col-12">
                    Size: {{ customerSignature.length }} Byte
                </div>
            </ng-container>
        </div>
        <div class="col-12 col-sm-6">
            <ng-container class="cseSignature col-6" *ngIf="!!cseSignature">
                <label class="col-12 col-form-label text-start" translate="CONFIRMATION_SIGNATURE_CSE_LABEL"></label>
                <div class="col-12 col-lg-10">
                    <img class="w-100" *ngIf="cseSignatureUrl" [src]="cseSignatureUrl" alt="CSE signature" />
                </div>
                <div *ngIf="!!cseSignature" class="d-block d-lg-none col-12">Size: {{ cseSignature.length }} Byte</div>
            </ng-container>
        </div>
    </div>
    <div class="row d-none d-lg-flex">
        <div *ngIf="!!customerSignature" class="col-4 offset-md-2">Size: {{ customerSignature.length }} Byte</div>
        <div *ngIf="!!cseSignature" class="col-4 offset-md-2">Size: {{ cseSignature.length }} Byte</div>
    </div>
</div>
<div class="modal-footer">
    <button
        class="btn btn-secondary customNoClass"
        translate="CONFIRMATION_SIGNATURE_CANCEL"
        (click)="onCancel()"
    ></button>
    <button class="btn btn-primary" translate="CONFIRMATION_SIGNATURE_SUBMIT" (click)="onSubmit()"></button>
</div>
